import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import theme from '../../theme.jsx';

const PlaceholderPage = ({ title, task }) => {
  const muiTheme = theme({ borderRadius: 12, navType: 'light' });

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3" sx={{ color: muiTheme.palette.text.primary }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: muiTheme.palette.text.secondary }}>
        This page will be implemented in {task}
      </Typography>
    </Box>
  );
};

PlaceholderPage.propTypes = {
  title: PropTypes.string.isRequired,
  task: PropTypes.string.isRequired,
};

export default PlaceholderPage;
